export const institutionalEffectivenessEnabled = true;

export const MAIN_MIN_HEIGHT = "calc(100vh - 3rem)";
export const EXTERNAL_MAIN_MIN_HEIGHT = "calc(100vh - 3rem - 64px)";
